import React from 'react';

type AccountBSUDetailsProps = {
    term: string;
    description: string;
    isLoading?: boolean;
    skeleton?: JSX.Element;
};

const AccountBSUDetails: React.FC<AccountBSUDetailsProps> = ({ term, description, isLoading, skeleton }) => {
    return isLoading && skeleton ? (
        skeleton
    ) : (
        <>
            <dt className="bsu-details-term">{term}</dt>
            <dd className="bsu-details-description">
                <strong>{description}</strong>
            </dd>
        </>
    );
};
export default AccountBSUDetails;
